import agent from "../api/agent";

export type StatisticStore = {
    loading: boolean;

    totalMembersIncludingFamily: number;
    totalMaleMembers: number;
    totalFemaleMembers: number;

    totalActiveMembers: number;
    totalInactiveMembers: number;
    totalPendingMembers: number;
    totalArchivedMembers: number;

    totalMembershipPaymentsPerYear: { year: number; totalPayments: number }[];
    totalMembersPerYear: { year: number; totalMembers: number }[];
    newMembersByMonth: { monthLabel: string; count: number }[];
    totalMembers: number;
    totalZekatPaymentsPerYear: { year: number; totalPayments: number }[];
    totalMembersByMembershipFee: { membershipGroupFee: number; totalMembers: number }[];
    newMembersLast12Months: number;

    loadStatistics: () => Promise<void>;
};

export const createStatisticStore = (set: any, _get: any): StatisticStore => ({
    loading: false,

    totalMembersIncludingFamily: 0,
    totalMaleMembers: 0,
    totalFemaleMembers: 0,

    totalActiveMembers: 0,
    totalInactiveMembers: 0,
    totalPendingMembers: 0,
    totalArchivedMembers: 0,

    totalMembershipPaymentsPerYear: [],
    totalMembersPerYear: [],
    newMembersByMonth: [],

    totalMembers: 0,
    totalZekatPaymentsPerYear: [],
    totalMembersByMembershipFee: [],
    newMembersLast12Months: 0,

    loadStatistics: async () => {
        set((s: any) => ({ statisticStore: { ...s.statisticStore, loading: true } }));
        try {
            // Use consolidated endpoint for better performance
            const dashboardData = await agent.Statistics.getDashboardData();

            set((s: any) => ({
                statisticStore: {
                    ...s.statisticStore,
                    totalMembers: dashboardData.totalMembers,
                    totalActiveMembers: dashboardData.totalActiveMembers,
                    totalInactiveMembers: dashboardData.totalInactiveMembers,
                    totalPendingMembers: dashboardData.totalPendingMembers,
                    totalArchivedMembers: dashboardData.totalArchivedMembers,
                    totalMaleMembers: dashboardData.totalMaleMembers,
                    totalFemaleMembers: dashboardData.totalFemaleMembers,
                    totalMembersIncludingFamily: dashboardData.totalMembersIncludingFamily,
                    newMembersLast12Months: dashboardData.newMembersLast12Months,
                    totalMembershipPaymentsPerYear: dashboardData.totalMembershipPaymentsPerYear,
                    totalZekatPaymentsPerYear: dashboardData.totalZekatPaymentsPerYear,
                    totalMembersByMembershipFee: dashboardData.totalMembersByMembershipFee,
                    totalMembersPerYear: dashboardData.totalMembersPerYear,
                    newMembersByMonth: dashboardData.newMembersByMonth,
                    loading: false,
                },
            }));
        } catch (e) {
            console.error(e);
            set((s: any) => ({ statisticStore: { ...s.statisticStore, loading: false } }));
        }
    },
});
